(() => {
  'use strict';

  angular
    .module('app.settings')
    .controller('IntegrationsDFPController', IntegrationsDFP);

  IntegrationsDFP.$inject = ['$http', '$location'];

  function IntegrationsDFP($http, $location) {
    const vm = this;
    vm.loading = true;

    vm.getDataPromise = (config) => {
      let params = '';
      if (config) {
        params = '/?' + Object.keys(config).reduce((memo, key) => [...memo, key + '=' + config[key]], []).join(';');
      }

      const { token, accountId, dfpUrl } = window.DFP_CONFIG;
      return $http({
        url: dfpUrl + accountId + '/sync-status' + params,
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token }
      });
    }

    vm.getDataPromise().then(({ data }) => {
      vm.loading = false;
      vm.pageSize = data.pageSize;
      vm.nextToken = data.nextToken;
      vm.campaigns = data.campaigns;
      vm.totalCampaignsCount = data.totalCampaignsCount;
    });

    vm.loadMore = () => {
      vm.getDataPromise({
        nextToken: vm.nextToken
      }).then(({ data }) => {
        vm.nextToken = data.nextToken;
        vm.campaigns = data.campaigns.reduce((memo, item) => (
          [...vm.campaigns, item]
        ), vm.campaigns);
      });
    }

    vm.getCampaignStatus = ({ impressionsDfp, impressionsAr }) => {
      const max = Math.max(impressionsDfp, impressionsAr);
      const min = Math.min(impressionsDfp, impressionsAr);
      return ((max - min) * 100) / (max || 1);
    };

    vm.gotoBack = () => {
      $location.path('apiintegrations');
    };
  }
})();
